import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import ApplicationStepper from "@/components/application/ApplicationStepper";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PhoneCall, Calendar, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const ScreeningPage: React.FC = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />

        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Screening Call
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Thanks for your application. Our team will contact you shortly to
          schedule your screening call.
        </p>

        <div className="max-w-md mx-auto">
          <Card>
            <CardHeader className="text-center">
              <div className="flex justify-center mb-4">
                <div className="rounded-full bg-green-100 p-3">
                  <PhoneCall className="h-8 w-8 text-green-600" />
                </div>
              </div>
              <CardTitle className="text-xl font-bold text-jungle mb-2">
                We'll be in touch soon
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-start space-x-3 bg-gray-50 p-4 rounded-lg">
                <div className="rounded-full bg-amber-100 p-2">
                  <Calendar className="h-5 w-5 text-amber-600" />
                </div>
                <p className="text-sm text-gray-600">
                  We'll propose times for your screening call. Please pick what
                  works best for you.
                </p>
              </div>
              <div className="flex items-start space-x-3 bg-gray-50 p-4 rounded-lg">
                <div className="rounded-full bg-blue-100 p-2">
                  <Mail className="h-5 w-5 text-blue-600" />
                </div>
                <p className="text-sm text-gray-600">
                  Watch your inbox and phone for updates. Make sure your contact
                  details are up-to-date.
                </p>
              </div>
              <div className="flex items-start space-x-3 bg-gray-50 p-4 rounded-lg">
                <div className="rounded-full bg-green-100 p-2">
                  <PhoneCall className="h-5 w-5 text-green-600" />
                </div>
                <p className="text-sm text-gray-600">
                  No action required now — we’ll reach out to you to schedule.
                </p>
              </div>
            </CardContent>
            <CardFooter className="flex justify-center">
              <Link to="/application-status" className="w-full">
                <Button variant="outline" className="w-full">
                  View application status
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </div>
    </AppLayout>
  );
};

export default ScreeningPage;
